import { useTranslation } from "react-i18next";

import { useCallContextRule } from "@/hooks/useCallContextRule/useCallContextRule";
import { SectionCallEvaluation } from "../SectionCallEvaluation";
import { SectionCsat, useCsat } from "../SectionCsat";
import { SectionCustomSummary } from "../SectionCustomSummary/SectionCustomSummary";
import { SectionKeyTopics } from "../SectionKeyTopics/SectionKeyTopics";
import { SectionNextActions } from "../SectionNextActions/SectionNextActions";
import { SectionPlaybook } from "../SectionPlaybook/SectionPlaybook";
import { SectionSentiment } from "../SectionSentiment";
import { SectionTalkRatio } from "../SectionTalkRatio";

function InsightsSection() {
  const {
    isTalkRatioDisplayed,
    shouldDisplaySentiments,
    shouldDisplayEvaluation,
  } = useCallContextRule();

  const csat = useCsat();

  return (
    <div className="flex flex-col gap-6">
      <SectionCustomSummary />
      <SectionPlaybook />
      <SectionKeyTopics />
      <SectionNextActions />
      {shouldDisplayEvaluation && <SectionCallEvaluation />}
      {shouldDisplaySentiments && <SectionSentiment />}
      {csat && <SectionCsat score={csat.score} drivers={csat.drivers} />}
      {isTalkRatioDisplayed && <SectionTalkRatio />}
    </div>
  );
}

export function SectionCallContext() {
  const { t } = useTranslation();
  const { shouldDisplayInsights } = useCallContextRule();

  if (!shouldDisplayInsights) {
    return (
      <p
        className="text-sm font-normal text-muted-foreground"
        data-test="call-context-section"
      >
        {t("call_context.no_insights")}
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-6" data-test="call-context-section">
      <InsightsSection />
    </div>
  );
}
